import { render } from "./Expenses.vue?vue&type=template&id=065143e1"
import script from "./Expenses.vue?vue&type=script&lang=js"
export * from "./Expenses.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matt/websites/code-practice.test/portfolio/expense-tracker/vuecli/expense-tracker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__